/**
 * @author Joshmar Morales
 */
import { setupWeather } from "./controllers/weatherController.js";

const init = function () {
  setupWeather();
};

init();
